import {
	Id,
	keyToUrl,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import {
	AddressIndexResource,
	AddressSaveRequest,
	AddressUpdateResource,
	CompanyAddressSaveRequest,
	CompanyAddressUpdateResource,
} from "../types";

const baseKey = "addresses";
const markAsPrimaryKey = (id: Id) => [baseKey, `${id}`, "change-primary"];
export const addressService = {
	...withIndexEndpoint<AddressIndexResource>([baseKey]),
	...withShowEndpoint<AddressUpdateResource>([baseKey]),
	...withDestroyEndpoint([baseKey]),
	...withStoreEndpoint<AddressSaveRequest>([baseKey]),
	...withUpdateEndpoint<AddressSaveRequest>([baseKey]),
	markAsPrimary: (id: Id) => axios.put(keyToUrl(markAsPrimaryKey(id))),
	markAsPrimaryKey,
};

export const companyAddressService = {
	...withIndexEndpoint<AddressIndexResource>([baseKey]),
	...withShowEndpoint<CompanyAddressUpdateResource>([baseKey]),
	...withDestroyEndpoint([baseKey]),
	...withStoreEndpoint<CompanyAddressSaveRequest>([baseKey]),
	...withUpdateEndpoint<CompanyAddressSaveRequest>([baseKey]),
};
